<template>
  <div class="address-list">
    <div class="row" v-if="loading">
      <div class="col-md-12">
        <spinner :show="true"/>
      </div>
    </div>
    <div v-else class="card">
      <div class="card-body p-2">
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0 d-inline-block">
                  {{$t('Billing Addresses')}}
                </h5>
                <b-button class="float-right p-0" variant="link"
                          v-permission="'change_customeraddress'"
                          @click="showAddressModal({source: SOURCE_ADDRESS_LIST, object: {type: 'billing'}})">
                  <font-awesome-icon :icon="'plus'" style="font-size: .9em"></font-awesome-icon>
                  {{$t('New Address')}}
                </b-button>
              </div>
              <div class="card-body">
                <div class="row h-100 addresses-row">
                  <div class="col-md-12"
                       :class="{'mt-3': index > 0}"
                       v-for="(address, index) in billingAddresses"
                       :key="address.uuid">
                    <AddressViewer :address="address"
                                   @onEditClick="showAddressModal({source: SOURCE_ADDRESS_LIST, object: address})"
                                   @onRemoveClick="onRemoveClick(address)"
                                   :key="index"></AddressViewer>
                  </div>
                  <div class="col-md-12" v-if="billingAddresses.length === 0">
                    <no-data-available :height="16"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0 d-inline-block">
                  {{$t('Shipping/Collection Addresses')}}
                </h5>
                <b-button class="float-right p-0" variant="link"
                          v-if="$hasPermission('change_customeraddress')"
                          @click="showAddressModal({source: SOURCE_ADDRESS_LIST, object: {type: 'shipping'}})">
                  <font-awesome-icon :icon="'plus'" style="font-size: .9em"></font-awesome-icon>
                  {{$t('New Address')}}
                </b-button>
              </div>
              <div class="card-body">
                <div class="row h-100">
                  <div class="col-md-12"
                       :class="{'mt-3': index > 0}"
                       v-for="(address, index) in shippingAddresses"
                       :key="address.uuid">
                    <AddressViewer :address="address"
                                   @onEditClick="showAddressModal({source: SOURCE_ADDRESS_LIST, object: address})"
                                   @onRemoveClick="onRemoveClick(address)"
                                   :key="index"></AddressViewer>
                  </div>
                  <div class="col-md-12" v-if="shippingAddresses.length === 0">
                    <no-data-available :height="16"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AddressViewer from "./AddressViewer";
  import {createNamespacedHelpers} from 'vuex';
  import NoDataAvailable from "../../../../core/components/common/NoDataAvailable";
  import Spinner from "../../../../core/components/common/Spinner";
  import {SOURCE_ADDRESS_LIST} from "../../../constants";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "AddressList",
    components: {Spinner, NoDataAvailable, AddressViewer},
    data() {
      return {
        SOURCE_ADDRESS_LIST: SOURCE_ADDRESS_LIST
      }
    },
    methods: {
      ...mapActions([
        'showAddressModal',
        'removeAddress',
        'getAddressListAddresses'
      ]),
      async onRemoveClick(address) {
        this.$confirm(
          this.$i18n.t('Are you sure you want to delete following address?'),
          this.$i18n.t('Address has been successfully deleted'),
          this.removeAddress,
          {source: SOURCE_ADDRESS_LIST, uuid: address.uuid, type: address.type}
        );
      }
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
        loading: state => state.addressListData.loading,
        billingAddresses: state => state.addressListData.billingAddresses,
        shippingAddresses: state => state.addressListData.shippingAddresses,
      })
    },
    beforeMount() {
      this.getAddressListAddresses();
    }
  }

</script>

<style lang="scss" scoped>
  @import "./../../scss/variables";
</style>
